import React from "react";
import { BaseProps, Field } from "./field";
import {
  Box,
  FormControlLabel,
  Radio as MUIRadio,
  Tooltip,
} from "@material-ui/core";
import { InfoOutlined as InfoOutlinedIcon } from "@material-ui/icons";

type Props = Pick<
  BaseProps<boolean>,
  Exclude<keyof BaseProps, "error" | "required">
>;

export const Radiobutton: React.FC<Props> = (props) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>): void {
    if (props.onChange) {
      props.onChange(props.name, event.target.checked);
    }
  }

  return (
    <Field size={props.size}>
      <FormControlLabel
        control={
          <MUIRadio
            checked={props.value}
            disabled={props.disabled}
            onChange={onChange}
            name={props.name}
            color="primary"
            size="small"
          />
        }
        label={
          props.label ? (
            typeof props.label === "string" ? (
              <React.Fragment>{props.label}</React.Fragment>
            ) : (
              <Box display="flex" alignItems="center">
                <Box display="inline" pr={props.label.tooltip ? 0.5 : 0}>
                  {props.label.text}
                </Box>
                {props.label.tooltip ? (
                  <Tooltip arrow title={props.label.tooltip}>
                    <InfoOutlinedIcon color="primary" fontSize="small" />
                  </Tooltip>
                ) : null}
              </Box>
            )
          ) : null
        }
      />
    </Field>
  );
};
